"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const productCategory_1 = __importDefault(require("@powerednow/shared/constants/productCategory"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class UserTaxRateFilter extends complexData_1.default {
    static get notRequiredFieldValue() {
        return productCategory_1.default.TAX_CATEGORY.NONE.ID;
    }
    static get allowedAssociations() {
        return {
            userTaxRate: {
                key: 'userTaxRate',
                instance: (0, modelLookup_1.complexFindModel)('UserTaxRate'),
                single: true,
                condition: {
                    id: this.Entity.getFieldSymbols().taxrate_id,
                },
            },
            countryGroup: {
                key: 'countryGroup',
                instance: (0, modelLookup_1.complexFindModel)('CountryGroup'),
                single: true,
                condition: {
                    id: this.Entity.getFieldSymbols().country_group_id,
                },
            },
        };
    }
    async allowedForTargetCountry(sourceCountryId, targetCountryId) {
        if (this.isInlandDefinition()) {
            return sourceCountryId === targetCountryId;
        }
        //
        // use self_included if defined, and target country would the sames as source
        //
        if (this.isSelfIncludedFieldDefined() && UserTaxRateFilter.isTargetCountryIsInland(sourceCountryId, targetCountryId)) {
            return this.data.self_included;
        }
        const countryGroup = await this.getCountryGroup();
        if (countryGroup) {
            const country = await countryGroup.findCountry(targetCountryId);
            return this.isCountryAvailable(country);
        }
        return false;
    }
    isFieldRequired(fieldName) {
        return this.data[fieldName] !== UserTaxRateFilter.notRequiredFieldValue;
    }
    isFieldAvailable(fieldName) {
        return this.data[fieldName] !== undefined;
    }
    isCountryAvailable(country) {
        return this.data.negate_group ? !country : !!country;
    }
    isInlandDefinition() {
        return !this.data.country_group_id && this.data.self_included && !this.data.negate_group;
    }
    isSelfIncludedFieldDefined() {
        return this.data.self_included !== null && this.data.self_included !== undefined;
    }
    static isTargetCountryIsInland(sourceCountryId, targetCountryId) {
        return sourceCountryId === targetCountryId;
    }
}
UserTaxRateFilter.Entity = entity_1.default;
UserTaxRateFilter.modelProperties = modelProperties_1.default;
exports.default = UserTaxRateFilter;
//# sourceMappingURL=../../../../src/models/userTaxRateFilter/index.js.map